import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../../shared';
import { InvoiceManagementService } from '../../../management/invoice-management.service';
import * as InvoiceChargeNumberActions from './invoice-charge-number.actions';

@Injectable()
export class InvoiceChargeNumberEffects {
    getInvoiceChargeNumbers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvoiceChargeNumberActions.getInvoiceChargeNumbers),
            switchMap(action =>
                this.service
                    .getChargeNumbers(
                        action.ScheduledStartDate,
                        action.ScheduledEndDate,
                        action.ContractListID,
                        action.ContractDesc,
                        action.showInactive
                    )
                    .pipe(
                        map(data =>
                            InvoiceChargeNumberActions.loadInvoiceChargeNumbers(
                                { invoiceChargeNumbers: data }
                            )
                        ),
                        // retryBackoff({ initialInterval: 3000, maxRetries: 3 }),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: InvoiceManagementService
    ) {}
}
